// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Call: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 38" enableBackground="new 0 0 38 38" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M35.67,26.31c-2.58,0-5.1-0.42-7.44-1.19c-0.73-0.25-1.56-0.06-2.12,0.5
	l-4.58,4.58c-5.9-3.02-10.73-7.83-13.73-13.73l4.58-4.58c0.58-0.58,0.75-1.4,0.52-2.12c-0.77-2.33-1.19-4.83-1.19-7.44
	c0-1.15-0.94-2.08-2.08-2.08H2.33c-1.15,0-2.08,0.94-2.08,2.08c0,19.56,15.85,35.42,35.42,35.42c1.15,0,2.08-0.94,2.08-2.08V28.4
	C37.75,27.25,36.81,26.31,35.67,26.31z"/>
</svg>;
};

export default React.memo(Call);
